export default "__VITE_ASSET__CDfzwQKj__"